import { CompanyAuthenticationTabWebComponent } from '../../../common/authenticationTab';
import { CompanyDetailsTabWebComponent } from '../../../common/companyDetailsTab';
import { CompanyLicensingTabWebComponent } from '../../../common/licensingTab';
import { CompanyMspInProductTrialsTabWebComponent } from '../../../common/mspInProductTrialsTab';

export type EditCompanyPanelTabComponents =
  | CompanyAuthenticationTabWebComponent
  | CompanyDetailsTabWebComponent
  | CompanyLicensingTabWebComponent
  | CompanyMspInProductTrialsTabWebComponent;

export enum TabIndex {
  DETAILS,
  AUTHENTICATION,
  LICENSING,
  MSP_IN_PRODUCT_TRIALS,
}